import { Component, Vue } from 'vue-property-decorator';

import template from './no-rooms.vue';
import { Action } from '@/store';
import { ModalState } from '@/definitions';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class NoRooms extends Vue {

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  deleteReservation() {
    this.$router.push('/settings');
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}